/// <reference path="../typings/index.d.ts" />
/**
 * The EVA Service factory is used to created a fully type enabled instance
 * of an EVA backend service
 *
 * @export
 * @template SVC The type of EVA service
 * @param {new () => SVC} service The EVA service definition
 * @returns {SVC} Instantiated EVA service definition
 */
export function createServiceDefinition(service) {
    return new service();
}
/**
 * Expose the service definitions API version
 */
export * from './api-version.js';
/**
 * Expose the service definitions for EVA.Core
 */
export * from './EVA.Core.Services.js';
//# sourceMappingURL=eva-services-core.js.map